import React from 'react';
import { Box } from 'grid-styled';
import { FormattedMessage } from 'react-intl';

import Container from 'components/Container';
import Heading from 'components/Heading';
import SubHeading from 'components/SubHeading';
import ApplicationTable from 'components/ApplicationTable';
import { COLOR, FONT_SIZES, FONT_FAMILIES } from 'config';
import infoIcon from './info_icon.svg';

import { downloads, version } from './downloads';
import sortByMobile from '../../sort';

const orderedDownloads = sortByMobile(downloads);

const disclaimerStyle = {
  display: 'flex',
  background: '#f4f4f4',
  textTransform: 'initial',
  color: COLOR.base,
  fontFamily: FONT_FAMILIES.sans,
  fontSize: `${FONT_SIZES[2]}px`,
  padding: '20px',
  marginTop: '-35px',
  marginBottom: '25px',
  alignItems: 'center',
  lineHeight: '1.5',
};

const disclaimerIconStyle = {
  height: '20px',
  width: '20px',
  marginRight: '15px',
};

const disclaimerLinkStyle = {
  color: COLOR.base,
};

const Wallet = () => (
  <div>
    <Container>
      <Box width={[1 / 1, 1 / 1, 2 / 3]} my={[5, 7]}>
        <Heading heavy as="h2" fontSize={[6, 7]} color={COLOR.textDark} mb={2}>
          <FormattedMessage id="downloads.wallet.heading" />
        </Heading>

        <SubHeading fontSize={[1, 1, 2]} normal mb={[8, 10]}>
          <FormattedMessage id="downloads.wallet.build" values={{ version }} />
        </SubHeading>
      </Box>

      <div style={disclaimerStyle}>
        <img alt="" src={infoIcon} style={disclaimerIconStyle} />
        <div>
          <FormattedMessage id="downloads.wallet.disclaimer1" />&nbsp;
          <a href="/terms" style={disclaimerLinkStyle}>
            <FormattedMessage id="downloads.wallet.disclaimer2" />
          </a>
        </div>
      </div>

      <ApplicationTable list={orderedDownloads} />
    </Container>
  </div>
);

export default Wallet;



// WEBPACK FOOTER //
// ./src/components/Downloads/components/Wallet/Wallet.js